<template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th>Serviço</th>
          <th>Tipo</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in facilitatorItems" :key="item.id">
          <td>
            {{ item.name }}
          </td>
          <td :style="{ width: '10rem' }">
            {{ formatMedicalRequestItemType(item) }}
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { findMedicalRequestItemTypeDisplayName } from "@/components/config/medical_request/item_facilitators/medical_request_types.js";

export default {
  name: "MedicalRequestItemFacilitatorItemTable",
  props: {
    facilitatorItems: {
      type: Array,
      required: true,
    },
  },
  methods: {
    formatMedicalRequestItemType(item) {
      return findMedicalRequestItemTypeDisplayName(item.medicalRequestType);
    },
  },
};
</script>

<style scoped></style>
